// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/deployment_environment_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FieldMask, proto3 } from "@bufbuild/protobuf";
import { DeploymentEnvironment } from "./deployment_environment_pb.js";
import { FilterRequest, KeySelection, PagingRequest, PagingResponse, SortingRequest } from "./listing_pb.js";
import { Deployment, DeploymentType, SecondaryScorer } from "./deployment_pb.js";
import { Metadata } from "./entity_pb.js";

/**
 * @generated from message ai.h2o.storage.GetDeploymentEnvironmentRequest
 */
export const GetDeploymentEnvironmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetDeploymentEnvironmentRequest",
  () => [
    { no: 1, name: "deployment_environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetDeploymentEnvironmentResponse
 */
export const GetDeploymentEnvironmentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetDeploymentEnvironmentResponse",
  () => [
    { no: 1, name: "deployment_environment", kind: "message", T: DeploymentEnvironment },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateDeploymentEnvironmentRequest
 */
export const CreateDeploymentEnvironmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateDeploymentEnvironmentRequest",
  () => [
    { no: 1, name: "deployment_environment", kind: "message", T: DeploymentEnvironment },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateDeploymentEnvironmentResponse
 */
export const CreateDeploymentEnvironmentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateDeploymentEnvironmentResponse",
  () => [
    { no: 1, name: "deployment_environment", kind: "message", T: DeploymentEnvironment },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateDeploymentEnvironmentRequest
 */
export const UpdateDeploymentEnvironmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateDeploymentEnvironmentRequest",
  () => [
    { no: 1, name: "deployment_environment", kind: "message", T: DeploymentEnvironment },
    { no: 2, name: "update_mask", kind: "message", T: FieldMask },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateDeploymentEnvironmentResponse
 */
export const UpdateDeploymentEnvironmentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateDeploymentEnvironmentResponse",
  () => [
    { no: 1, name: "deployment_environment", kind: "message", T: DeploymentEnvironment },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteDeploymentEnvironmentRequest
 */
export const DeleteDeploymentEnvironmentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteDeploymentEnvironmentRequest",
  () => [
    { no: 1, name: "deployment_environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListDeploymentEnvironmentsRequest
 */
export const ListDeploymentEnvironmentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListDeploymentEnvironmentsRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListDeploymentEnvironmentsResponse
 */
export const ListDeploymentEnvironmentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListDeploymentEnvironmentsResponse",
  () => [
    { no: 1, name: "paging", kind: "message", T: PagingResponse },
    { no: 2, name: "deployment_environment", kind: "message", T: DeploymentEnvironment, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeployRequest
 */
export const DeployRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeployRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "deployment_environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(DeploymentType) },
    { no: 4, name: "secondary_scorer", kind: "message", T: SecondaryScorer, repeated: true },
    { no: 5, name: "metadata", kind: "message", T: Metadata },
    { no: 6, name: "response_metadata", kind: "message", T: KeySelection },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeployResponse
 */
export const DeployResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeployResponse",
  () => [
    { no: 1, name: "deployment", kind: "message", T: Deployment },
  ],
);

